import fullpage from 'fullpage.js'

export default function ({ app }, inject) {
  // 在客户端注入 fullpage
  if (process.client) {
    inject('fullpage', fullpage)
  }
}
